import { get,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";



export const getDopingsByUserTypeId = async (userTypeId:number): Promise<DataResponse<any>> => {
  
    const url = `${endpoints.getDopingsByUserTypeId}/${userTypeId}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };
 
  